import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ISchool } from "src/app/core/models/academic";
import { IStudent } from "../../models/user";
import { selectAllStudents, selectSelectedStudent } from "../students/student.selectors";
import { SchoolState } from "./school.reducer";

export const selectSchoolState = createFeatureSelector<SchoolState>('schools');

export const selectAllSchools = createSelector(
    selectSchoolState,
    (state: SchoolState) => state.schools
);

export const selectSelectedSchool = createSelector(
    selectSchoolState,
    (state: SchoolState) => state.selectedSchool
);

export const selectSchoolById = (schoolId: string) => createSelector(
    selectAllSchools,
    (schools: ISchool[]) => schools.find(school => school.id === schoolId)
);

export const selectSchoolNameById = (schoolId: string) => createSelector(
    selectAllSchools,
    (schools: ISchool[]) => {
        const school = schools.find(school => school.id === schoolId);
        return school ? school.name : '';
    }
);

export const selectSchoolNameByLearnerId = (learnerId: string) => createSelector(
    selectSchoolState,
    selectAllStudents,
    (schoolState: SchoolState, students: IStudent[]) => {
        const student = students.find(student => student.id === learnerId);
        if (!student || !student.schoolId) {
            return '';
        }

        const school = schoolState.schools.find(school => school.id === student.schoolId);
        return school ? school.name : '';
    }
);

// Selector to retrieve the selected school's ID (returns empty string if no school is selected)
export const selectSelectedSchoolId = createSelector(
    selectSelectedSchool,
    (school: ISchool | null) => school ? school.id : ''
);

// Selector to get the school executives based on the selected student's school
export const selectSchoolExecutives = createSelector(
    selectSchoolState,
    selectSelectedStudent,
    (schoolState: SchoolState, selectedStudent: IStudent | null) => {
        if (!selectedStudent || !selectedStudent.schoolId) {
            return [];
        }

        // Find the school that matches the student's schoolId
        const matchingSchool = schoolState.schools.find(school => school.id === selectedStudent.schoolId);

        // If a matching school is found, return its executives; otherwise, return an empty array
        return matchingSchool ? matchingSchool.executives : [];
    }
);

//Get all school names and their 